import { QueryClient } from "@tanstack/react-query";

import { config } from "@/config/config";

export const API_URL = config.baseUrl;

// Configuração global do query client com retry e políticas de cache padrão
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
      staleTime: 5 * 60 * 1000, // 5 minutos
    },
    mutations: {
      retry: 0,
    },
  },
});
